import { useMutation } from "@tanstack/react-query";
import {
  gameFinishShootOut,
  gameRevokeShootOutShot,
  gameTrackShootOutShot,
} from "../openapi/api-client";

export const useShootoutMutations = (gameId: string) => {
  const trackShotMutation = useMutation({
    mutationFn: gameTrackShootOutShot,
  });
  const revokeShotMutation = useMutation({
    mutationFn: gameRevokeShootOutShot,
  });
  const finishMutation = useMutation({
    mutationFn: gameFinishShootOut,
  });

  return {
    trackShot: (teamId: string, success: boolean) =>
      trackShotMutation.mutateAsync({ id: gameId, teamId, success }),
    revokeLastShot: () => revokeShotMutation.mutateAsync({ id: gameId }),
    finishShootout: () => finishMutation.mutateAsync({ id: gameId }),
    isLoading:
      trackShotMutation.isPending ||
      revokeShotMutation.isPending ||
      finishMutation.isPending,
  };
};
